module.exports = __webpack_public_path__ + "static/paris-011-69431d5a6a9d8f62622e42f4f9b83a80.jpg";